"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _theming = require("../../../../theming");

var _themeContants = require("../../../../constants/themeContants");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Slider =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Slider, _React$PureComponent);

  function Slider(props, context) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props, context));
    _this.state = {
      percentage: props.value ? props.value / props.max : props.max * 0.5
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Slider, [{
    key: "handleChange",
    value: function handleChange(e) {
      var value = e.target.value;
      var percentage = value / this.props.max;
      this.setState({
        percentage: percentage
      });
      this.props.onChange(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          max = _this$props.max,
          min = _this$props.min,
          name = _this$props.name,
          step = _this$props.step,
          value = _this$props.value,
          variantStyle = _this$props.variantStyle,
          variant = _this$props.variant,
          ignoreBase = _this$props.ignoreBase,
          restProps = _objectWithoutProperties(_this$props, ["disabled", "max", "min", "name", "step", "value", "variantStyle", "variant", "ignoreBase"]);

      return _react["default"].createElement(SliderInput, {
        percentage: this.state.percentage,
        variant: variant,
        ignoreBase: ignoreBase
      }, _react["default"].createElement("input", _extends({
        type: "range",
        name: name,
        defaultValue: value,
        min: min,
        max: max,
        step: step,
        disabled: disabled
      }, restProps, {
        onChange: this.handleChange
      })));
    }
  }]);

  return Slider;
}(_react["default"].PureComponent);

Slider.themeProps = {
  thumb: {
    name: "SLIDER_THUMB_STYLE",
    description: "Thumb style",
    type: _themeContants.themePropTypes.style
  },
  track: {
    name: "SLIDER_TRACK_STYLE",
    description: "Track style",
    type: _themeContants.themePropTypes.style
  },
  input: {
    name: "SLIDER_INPUT",
    description: "Input style",
    type: _themeContants.themePropTypes.style
  }
};
var SliderThumbStyle = (0, _styledComponents.css)(["-webkit-appearance:none;border:2px solid ", ";height:20px;width:20px;transform:translateY(-2px);border-radius:50%;background-color:", ";cursor:pointer;&:hover{background-color:", ";border-color:", ";}&:active,&:focus{border-color:", ";background-color:", ";}", ";"], _theming.color.line, _theming.color.white, _theming.color.bg, _theming.color.disabled, _theming.color.white, _theming.color.secondary, (0, _theming.applyVariants)(Slider.themeProps.thumb));
var SliderHiddenTrackStyle = (0, _styledComponents.css)(["width:100%;cursor:pointer;background-color:transparent;border-color:transparent;color:transparent;"]);
var SliderTrackStyle = (0, _styledComponents.css)(["width:100%;height:9px;cursor:pointer;border-radius:4.5px;color:transparent;background-color:", ";", ";"], _theming.color.line, (0, _theming.applyVariants)(Slider.themeProps.track));

var SliderInput = _styledComponents["default"].div.withConfig({
  displayName: "Slider__SliderInput",
  componentId: "jiifvk-0"
})(["position:relative;font-weight:", ";> input[type=\"range\"]{-webkit-appearance:none;width:100%;background-color:transparent;margin:0;background-clip:content-box;border-top:10px solid transparent;border-bottom:10px solid transparent;border-radius:6px;-webkit-tap-highlight-color:transparent;}> input[type=\"range\"]::-webkit-slider-thumb{-webkit-appearance:none;}> input[type=\"range\"]::-ms-track{", ";}> input[type=\"range\"]::-moz-range-track{", ";}> input[type=\"range\"]:focus{outline:none;}> input[type=\"range\"]:active{outline:none;}> input[type=\"range\"]:-moz-focusring,> input[type=\"range\"]:focusring{outline:1px solid white;outline-offset:-1px;}> input[type=\"range\"]::-webkit-slider-thumb{", ";margin-top:-3px;}> input[type=\"range\"]::-moz-range-thumb{", ";}> input[type=\"range\"]::-ms-thumb{", ";}input[type=\"range\"]::-webkit-slider-runnable-track{background:linear-gradient( 90deg,", " 0%,", " ", "%,", " ", "%,", " 100% ) 0 100% no-repeat content-box;", ";}input[type=\"range\"]:focus::-webkit-slider-runnable-track{}input[type=\"range\"]::-moz-range-track{", ";}input[type=\"range\"]::-moz-range-progress{background-color:", ";height:9px;border-radius:4.5px;}input[type=\"range\"]::-ms-track{", ";}input[type=\"range\"]::-ms-fill-lower{background-color:", ";}input[type=\"range\"]:focus::-ms-fill-lower{background-color:", ";}input[type=\"range\"]::-ms-fill-upper{background-color:", ";}input[type=\"range\"]:focus::-ms-fill-upper{background-color:", ";}", ";"], _theming.fontWeight.bold, SliderHiddenTrackStyle, SliderHiddenTrackStyle, SliderThumbStyle, SliderThumbStyle, SliderThumbStyle, _theming.color.primary, _theming.color.primary, function (p) {
  return p.percentage * 100;
}, _theming.color.line, function (p) {
  return p.percentage * 100 + 0.0;
}, _theming.color.line, SliderTrackStyle, SliderTrackStyle, _theming.color.primary, SliderTrackStyle, _theming.color.primary, _theming.color.white, _theming.color.white, _theming.color.white, (0, _theming.applyVariants)(Slider.themeProps.input));

Slider.defaultProps = {
  disabled: false,
  ignoreBase: null,
  max: 100,
  min: 0,
  step: 1,
  value: undefined
};
Slider.propTypes = {
  animationTicks: _propTypes["default"].number,
  disabled: _propTypes["default"].bool,
  ignoreBase: _propTypes["default"].bool,
  max: _propTypes["default"].number,
  min: _propTypes["default"].number,
  name: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func,
  step: _propTypes["default"].any,
  variant: _propTypes["default"].string,
  value: _propTypes["default"].any
};
var _default = Slider;
exports["default"] = _default;